import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const HungaryLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'HU',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Hungary',
  SHORT_NAME: 'HU',

  DISPLAY_NAME: 'Hungary (English)',
  DISPLAY_COUNTRY: 'Hungary (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 47.1345772,
    INITIAL_LONGITUDE: 16.8657582,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Bács-Kiskun',
    '2': 'Baranya',
    '3': 'Békés',
    '4': 'Borsod-Abaúj-Zemplén',
    '5': 'Budapest',
    '6': 'Csongrád-Csanád',
    '7': 'Fejér',
    '8': 'Győr-Moson-Sopron',
    '9': 'Hajdú-Bihar',
    '10': 'Heves',
    '11': 'Jász-Nagykun-Szolnok',
    '12': 'Komárom-Esztergom',
    '13': 'Nógrád',
    '14': 'Pest',
    '15': 'Somogy',
    '16': 'Szabolcs-Szatmár-Bereg',
    '17': 'Tolna',
    '18': 'Vas',
    '19': 'Veszprém',
    '20': 'Zala',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-hu/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-hu/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{4}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default HungaryLocale
